export default __webpack_public_path__ + "static/assets/65982d0fe3c1c51d5175066563e56087.png";